import React from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'
import {Button} from '../components/Button'
import {Card} from '../components/Card'
import {ImgFilters} from '../components/ImgFilters'
import heroImageDesk from '../img/AulaFree-Desk-1280x530.png'
import heroImageMobile from '../img/AulaFree-Mobile-450x530.png'
import aboutImage from '../img/EAD-01.png'
import waveRight from '../img/icons/wave-blue.svg'
import {useProfessorsQuery} from '../utils/hooks/useProfessorsQuery'

const MaxContainer = ({children}) => {
  return (
    <div className="w-full mx-auto" style={{maxWidth: '1003px'}}>
      {children}
    </div>
  )
}
export const Hero = ({className, imgDesktop, imgMobile}) => {
  const style = clsx(`relative w-full h-40 mb-4`, className)
  return (
    <div className={style}>
      <ImgFilters
        img={imgMobile}
        transparency
        className="lg:hidden"
        imgPosition="bg-center"
      />
      <ImgFilters
        img={imgDesktop}
        transparency
        className="hidden lg:block"
        imgPosition="bg-center"
      />
    </div>
  )
}

const About = ({className, title, subtitle, paragraph01, paragraph02}) => {
  const rootStyles = clsx('py-16', className)

  return (
    <div className={rootStyles}>
      <MaxContainer>
        <div className="px-4 grid gap-4 grid-cols-4 lg:grid-cols-12 lg:px-0">
          <div className="col-start-1 col-end-5 lg:col-end-8 space-y-6">
            <Typography variant="heading-4xl" color="blue-500" uppercase>
              {title}
            </Typography>
            <Typography size="lg">{subtitle}</Typography>
            <Typography>{paragraph01}</Typography>
            <div className="relative lg:hidden col-start-1 col-end-5 lg:col-start-8 lg:col-end-13">
              <div className="w-full h-full lg:absolute lg:w-c46 lg:-left-28">
                <img src={aboutImage} />
              </div>
            </div>
            <Typography>{paragraph02}</Typography>
          </div>
          <div className="relative hidden lg:block col-start-1 col-end-5 lg:col-start-8 lg:col-end-13">
            <div className="w-full h-full lg:absolute lg:w-c46 lg:-left-28">
              <img src={aboutImage} />
            </div>
          </div>
        </div>
      </MaxContainer>
    </div>
  )
}

const ProfessorCard = ({
  name,
  nameShort,
  description,
  descriptionShort,
  photo,
  link,
  slug,
}) => {
  return (
    <Card>
      <Card.Image src={photo} height="h-96 lg:h-60" />
      <Card.Content>
        <Card.Title title={name}>{nameShort || name}</Card.Title>

        <Typography
          color="gray-900"
          className="overflow-hidden truncate whitespace-nowrap"
          title={description}
        >
          {descriptionShort}
        </Typography>
      </Card.Content>
      <Card.Action>
        <Button as="a" fullWidth className="uppercase" href={`/${slug}`}>
          Saiba mais!
        </Button>
      </Card.Action>
    </Card>
  )
}

const ProfessorsPrimary = ({className}) => {
  const professors = useProfessorsQuery()

  const styleRoot = clsx(
    'bg-gradient-to-b from-blue-500 to-blue-900 text-white pt-10 pb-14',
    className,
  )

  return (
    <div className={styleRoot} style={{zIndex: '0'}}>
      <MaxContainer>
        <Typography
          variant="heading-3xl"
          uppercase
          align="center"
          size="2xl"
          className="lg:text-right lg:text-3xl"
        >
          IDEALIZADORES DO PORTAL
        </Typography>
        <div
          className="relative px-6 grid gap-4 grid-flow-row grid-cols-1 lg:grid-cols-4 lg:px-0"
          style={{zIndex: 2}}
        >
          {professors.slice(0, 4).map(professor => (
            <ProfessorCard
              key={`convidades-${professor.name}`}
              {...professor}
            />
          ))}
        </div>
      </MaxContainer>

      <div
        className="absolute hidden lg:block top-2/4 transform -translate-y-2/4"
        style={{width: '500px', height: '130%', zIndex: '1'}}
      >
        <img src={waveRight} className="w-full h-full" />
      </div>
    </div>
  )
}

const Professors = ({className}) => {
  const professors = useProfessorsQuery()

  const styleRoot = clsx('py-6', className)

  return (
    <div className={styleRoot}>
      <MaxContainer>
        <Typography
          size="2xl"
          variant="heading-3xl"
          color="blue-500"
          uppercase
          align="center"
          className="lg:text-left lg:text-3xl"
        >
          Professores Convidados
        </Typography>

        <div
          className="relative px-6 my-4 grid gap-4 grid-flow-row grid-cols-1 lg:grid-cols-4 lg:px-0"
          style={{zIndex: 2}}
        >
          {professors.slice(4).map(professor => (
            <ProfessorCard key={professor.name} {...professor} />
          ))}
        </div>
      </MaxContainer>
    </div>
  )
}

const Patreon = ({items = []}) => {
  return items.length === 0 ? null : (
    <MaxContainer>
      <Typography
        variant="heading-3xl"
        color="blue-500"
        uppercase
        align="center"
      >
        Parceiros
      </Typography>
      <div className="relative flex flex-wrap justify-center px-6 lg:px-0">
        {items.map(({image}, index) => (
          <div className="w-40 h-40 m-2" key={`apoiadores-${index}`}>
            <img src={image} alt="" className="object-contain w-full h-full" />
          </div>
        ))}
      </div>
    </MaxContainer>
  )
}

export const PageTemplate = ({
  title,
  subtitle,
  paragraph01,
  paragraph02,
  patreons,
}) => {
  const aboutProps = {title, subtitle, paragraph01, paragraph02}
  return (
    <div className="relative">
      <Hero imgDesktop={heroImageDesk} imgMobile={heroImageMobile} />
      <About className="relative" {...aboutProps} />
      <ProfessorsPrimary className="relative" />
      <Professors className="relative" />
      <Patreon items={patreons} />
    </div>
  )
}

const Template = ({pageContext}) => {
  return <PageTemplate {...pageContext?.frontmatter} />
}

export default Template
